import { Shifter } from './shifter';
import { Suggestor } from './suggestor';

export default function Header() {
    var header = document.querySelector('#header');

    var shifter = new Shifter(header.querySelector('.shifter'));
    shifter.init();
    header.querySelector('#menu-toggle').addEventListener('click', () => {
        document.body.classList.toggle('menu-open');
        if (!document.body.classList.contains('menu-open')) {
            shifter.reset();
        }
    });
    header.querySelector('.mobile-overlay').addEventListener('click', () => {
        document.body.classList.remove('menu-open');
    });

    /*var searchForm = header.querySelector('.expandable.search');

    var suggestor = new Suggestor({
        element: searchForm.querySelector('.suggestor'),
        callback: (value) => {
            searchInput.value = value;
            searchForm.submit();
        }
    });

    var searchInput = header.querySelector('.expandable.search input');
    searchInput.addEventListener('keyup', event => {
        suggestor.updateSuggestions(event.target.value);
    });
    searchInput.addEventListener('blur', event => {
        suggestor.hide();
    });*/
}